<!-- Dialog per il cambio password -->
<h1 mat-dialog-title>Modifica Password</h1>

<div mat-dialog-content>
  <!-- Form per il cambio password -->
  <form [formGroup]="passwordForm">
    
    <!-- Campo Vecchia Password -->
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Vecchia Password</mat-label>
      <input 
        matInput 
        [type]="hideOldPassword ? 'password' : 'text'" 
        formControlName="oldPassword"
        placeholder="Inserisci la vecchia password">
      <button 
        mat-icon-button 
        matSuffix 
        type="button"
        (click)="hideOldPassword = !hideOldPassword"
        [attr.aria-label]="'Mostra password'"
        [attr.aria-pressed]="!hideOldPassword">
        <mat-icon>{{hideOldPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      <!-- Messaggi di errore per vecchia password -->
      <mat-error *ngIf="oldPassword?.hasError('required')">
        La vecchia password è obbligatoria
      </mat-error>
    </mat-form-field>

    <!-- Campo Nuova Password -->
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Nuova Password</mat-label>
      <input 
        matInput 
        [type]="hideNewPassword ? 'password' : 'text'" 
        formControlName="newPassword"
        placeholder="Inserisci la nuova password">
      <button 
        mat-icon-button 
        matSuffix 
        type="button"
        (click)="hideNewPassword = !hideNewPassword"
        [attr.aria-label]="'Mostra password'"
        [attr.aria-pressed]="!hideNewPassword">
        <mat-icon>{{hideNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      <!-- Messaggi di errore per nuova password -->
      <mat-error *ngIf="newPassword?.hasError('required')">
        La nuova password è obbligatoria
      </mat-error>
      <mat-error *ngIf="newPassword?.hasError('minlength')">
        La password deve contenere almeno 6 caratteri
      </mat-error>
      <mat-error *ngIf="newPassword?.hasError('noNumber')">
        La password deve contenere almeno un numero
      </mat-error>
    </mat-form-field>

    <!-- Hint con i requisiti della password -->
    <div class="password-requirements">
      <mat-icon>info</mat-icon>
      <span>La password deve contenere almeno 6 caratteri e un numero</span>
    </div>

  </form>
</div>

<!-- Pulsanti di azione -->
<div mat-dialog-actions>
  <ct-button [configuration]="cancelButton"></ct-button>
  <ct-button [configuration]="confirmButton"></ct-button>
</div>
